/* Atikxzio's own product site. Swap to the production domain when it goes live. */
export const ATIKXZIO_SITE_URL = "https://www.dev.atikxzio.com";

/* Product name for the career + well-being product (may be renamed). */
export const CMH_NAME = "Atikxzio CMH";

export const COMPANY = {
  name: "Priyajit Systems",
  legal: "Priyajit Systems Private Limited",
  tagline: "Building Intelligent Solutions. Creating Real Impact.",
  pillars: "Technology · Innovation · Trust",
  phone: "+91 7050671269",
  phoneTel: "+917050671269",
  whatsapp: "917050671269",
  email: "Contact@priyajitsystems.in",
  careersEmail: "Careers@priyajitsystems.in",
  altEmail: "hello@priyajitcare.in",
  website: "www.priyajitsystems.in",
  address: "A-13, Upper Ground Floor, Graphix Tower 2, Sector 62, Noida, Gautam Buddha Nagar, Uttar Pradesh – 201301, India",
  cin: "U62012UW2026PTC257193",
  gstin: "09AARCP3967B1Z0",
  supportHours: "Monday–Saturday, 9:30 am–6:30 pm IST",
  grievanceName: "Ajit Kumar",
  grievanceEmail: "ajit@priyajitsystems.in",
  loginUrl: "https://www.dev.atikxzio.com/login",
  atikxzioSiteUrl: ATIKXZIO_SITE_URL,
  legalUpdated: "18 October 2026",
};

/* Real profile URLs go here when available; empty list hides social icons. */
export const SOCIALS = [];

export const IMG = {
  network: "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  networkAlt: "https://images.unsplash.com/photo-1644325349124-d1756b79dd42?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  b2c: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hospital: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  doctorTablet: "https://images.unsplash.com/photo-1758691462668-046fd85ceac9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  meditate: "https://images.pexels.com/photos/8436695/pexels-photo-8436695.jpeg?auto=compress&cs=tinysrgb&w=1200",
  wellbeing: "https://images.pexels.com/photos/6303797/pexels-photo-6303797.jpeg?auto=compress&cs=tinysrgb&w=1200",
};
